/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {
                $(".toggleMenu").click(function(e) {
                    e.preventDefault();
                    $("#primary-nav").slideToggle(200);
                });
                $('#primary-nav li a').click(function(e) {
                    // Grab current anchor value
                    var currentAttrValue = $(this).attr('href');
                    if($('.toggleMenu').css('display') == 'none'){
                        return false;
                    } else{
                        e.preventDefault();
                        $("#primary-nav").slideToggle(200);
                    }
                });
                $(window).resize(function() {
                    if( $(window).width() >= 1024) {
                        $("#primary-nav").show();                   
                    }
                });
                $("<i class='fa stock-font-class-003 fa-angle-right gci-red'></i>").insertAfter('#gform_submit_button_1');
                $("#gform_submit_button_1").addClass('stock-font-class-003');
                var header = $('header.banner .header-group');
                var headerHeight = header.outerHeight();
                $('.menu-item a').click(function(){
                    $('html, body').animate({
                        scrollTop: $( $.attr(this, 'href') ).offset().top - headerHeight
                    }, 500);
                    return false;
                });
                $(window).scroll(function(){
                    var scroll = $(window).scrollTop();
                    var heroHeight = $('#hero').outerHeight();
                    if (scroll >= heroHeight){
                        header.addClass('lightHeader');
                    } else{
                        header.removeClass('lightHeader');
                    }
                })
            },
            finalize: function() {
            }
        },
        // Home page
        'home': {
            init: function() {
                function close_accordion_section() {
                    $('.accordion .accordion-section-title').removeClass('active');
                    $('.accordion .accordion-section-content').slideUp(300).removeClass('open');
                }

                

                $('.accordion-section-title').click(function(e) {
                    // Grab current anchor value
                    var currentAttrValue = $(this).attr('href');

                    if($(this).hasClass('active')) {
                        close_accordion_section();
                    }else {
                        close_accordion_section();

                        // Add active class to section title
                        $(this).addClass('active');
                        // Open up the hidden content panel
                        $('.accordion ' + currentAttrValue).slideDown(300).addClass('open'); 
                    }

                    e.preventDefault();
                });
                $("#hero-flexslider").flexslider({
                    animation: "slide",
                    slideshow: true, 
                    animationLoop: true,
                    controlNav: true,
                    controlsContainer: ".control-nav .container",
                    directionNav: false,
                    prevText: "", 
                    nextText: "",
                    slideshowSpeed: 10000
                });
                $("#flexslider1").flexslider({
                    animation: "slide",
                    slideshow: false, 
                    animationLoop: true,
                    controlNav: false,
                    directionNav: false,
                    useCSS: false,
                    touch: false,
                    sync: "#flexslider3"
                });
                $("#flexslider2").flexslider({
                    animation: "slide",
                    slideshow: false,
                    animationLoop: true,
                    controlNav: false,
                    sync: "#flexslider1",
                    prevText: "", 
                    useCSS: false,
                    touch: false,
                    nextText: ""
                });
                $("#flexslider3").flexslider({
                    animation: "slide",
                    slideshow: false,
                    animationLoop: true,
                    controlNav: false,
                    directionNav: false,
                    useCSS: false,
                    touch: false,
                    sync: "#flexslider4"
                });
                $("#flexslider4").flexslider({
                    animation: "slide",
                    slideshow: false,
                    direction: "vertical",
                    animationLoop: true,
                    controlNav: false,
                    useCSS: false,
                    touch: false,
                    directionNav: false
                });
                $("#engagements-flexslider").flexslider({
                    animation: "slide",
                    slideshow: false,
                    reverse: true,
                    animationLoop: true,
                    controlNav: false, 
                    prevText: "", 
                    nextText: ""
                });

                $("#bio-grid").gridderExpander({
                  scroll: true,
                  scrollOffset: 60,
                  scrollTo: "panel", // "panel" or "listitem"
                  animationSpeed: 800,
                  animationEasing: "easeInOutExpo",
                  showNav: true,
                  onStart: function () {
                      console.log("Gridder Inititialized");
                  },
                  onExpanded: function (object) {
                      console.log("Gridder Expanded");
                      $(".carousel").carousel();
                  },
                  onChanged: function (object) {
                      console.log("Gridder Changed");
                  },
                  onClosed: function () {
                      console.log("Gridder Closed");
                  }
                });

            },
            finalize: function() {
            // JavaScript to be fired on the home page, after the init JS
            }
        }
    };
    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };
    // Load Events
    $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
